





















import { MaintenanceApi } from "@/api";
import { defineComponent, onMounted, ref } from "@vue/composition-api";

export default defineComponent({
  setup() {
    const api = new MaintenanceApi();

    const maintenanceTitle = ref("");
    const maintenanceText = ref("");

    async function getMaintenanceText() {
      const { data } = await api.maintenanceGetMaintenanceText();
      maintenanceTitle.value = data.title ?? "";
      maintenanceText.value = data.content ?? "";
    }

    onMounted(() => {
      getMaintenanceText();
    });
    return {
      maintenanceTitle,
      maintenanceText,
    };
  },
});
